<template>
    <div class="w-full md:pl-10 md:pr-10">
        <div class="mb-12" v-if="isAdmin">
            <label for="image" ref="tags">
                Please tag this resource with related categories to help people discover it. <span class="text-red">*</span>
                <div class="mb-5 text-sm font-sans-book">Make up to five choices.</div>
            </label>
            <div class="flex flex-wrap">
                <div class="w-full md:w-1/2 lg:w-1/4" v-for="pillar in pillars">
                    <h2>{{ pillar.title }}</h2>
                    <div class="flex flex-wrap select-box">
                        <div v-for="tag in pillar.tags" :key="tag.id" class="w-full pr-8 mb-3">
                            <label class="text-base font-sans-book">
                                <input name="tags" type="checkbox"
                                    v-validate="'required'"
                                    v-model="form.tags"
                                    :value="tag.id"
                                    :disabled="maxMet && form.tags.indexOf(tag.id) == -1">
                                    <span class="inline-block mr-2 check"></span>
                                    <span class="flex-1 wordbreak">{{ tag.title }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <span v-show="errors.has('tags')" class="text-lg error text-error-red">{{ errors.first('tags') }}</span>
        </div>

        <div class="w-full md:pl-10 md:w-3/4 md:pr-10 mb-8">
            <div class="mb-8" v-for="group in taxonomyGroups" :key="group.id">
                <label ref="taxonomy">
                    {{ group.title }} <span class="text-red">*</span>
                </label>
                <div class="group__checkbox">
                    <div class="flex flex-wrap select-box">
                        <template v-for="taxonomy in group.taxonomies">
                            <label class="w-full text-base font-normal md:w-1/2 md:pr-3" :key="taxonomy.id">
                                <input
                                    name="taxonomy"
                                    type="checkbox"
                                    v-validate="'required'"
                                    v-model="form.taxonomies"
                                    :value="taxonomy.id"
                                />
                                <span class="inline-block mr-2 check"></span> {{ taxonomy.title }}
                            </label>
                        </template>
                    </div>
                </div>
            </div>
            <span v-show="errors.has('taxonomy')" class="text-lg error text-error-red">{{ errors.first('taxonomy') }}</span>
        </div>

        <div class="mb-12">
            <label for="faiths">
                If applicable, please note any faiths this resource serves in particular.
            </label>
            <input id="faiths" type="text" name="faiths"
                v-model="form.faiths"
            >
                <div class="text-sm font-sans-italic text-gray-dark">Please separate with commas.</div>
            <span v-show="errors.has('faiths')" class="text-lg error text-error-red">{{ errors.first('faiths') }}</span>
        </div>

        <div class="mb-12">
            <label for="faith">
                If applicable, please note any demographics this resource serves in particular.
            </label>

            <input id="demographics" type="text" name="demographics"
                v-model="form.demographics"
            >
                <div class="text-sm font-sans-italic text-gray-dark">Please separate with commas. e.g. seniors, ill, LGBTQ, caregivers, pet owners, etc.</div>
            <span v-show="errors.has('demographics')" class="text-lg error text-error-red">{{ errors.first('demographics') }}</span>
        </div>

        <div class="mb-6 text-right">
            <button class="mr-4 button" @click.stop.prevent="save" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">
                <template v-if="saving">Processing...</template>
                <template v-else>Save</template>
            </button>
            <button class="button" @click.stop.prevent="saveNext" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">Save & Next</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import resourceSave from "../../../mixins/resource-save";
    import messaging from "../../../mixins/messaging";
    import validation from "../../../mixins/validation";

    export default {
        name: "ResourceCreateTags",
        mixins: [resourceSave, messaging, validation],
        data: () => ({
            form: {
                faiths: "",
                demographics: "",
                tags: [],
                taxonomies: []
            },
            next: "resource-submit"
        }),
        computed: {
            ...mapGetters({
                resource: "resource",
                user: "user",
                pillars: "pillars",
                taxonomyGroups: "taxonomyGroups"
            }),
            isAdmin() {
                return this.user.isAdmin;
            },
            maxMet() {
                return this.form.tags.length >= 5;
            }
        },
        watch: {
            resource(resource) {
                if (!_.isEmpty(resource)) {
                    this.form.suggestCategory = resource.suggestCategory;
                    this.form.faiths = resource.faiths;
                    this.form.demographics = resource.demographics;
                    
                    let tags = _.map(resource.tags, "id");
                    this.form.tags = tags;
                    
                    let taxonomies = _.map(resource.taxonomies, "id");
                    this.form.taxonomies = taxonomies;

                    this.$nextTick(function() {
                        this.$store.dispatch("setUnsavedData", false);
                    });
                }
            }
        },
        methods: {
            save() {
                this.saving = true;

                return this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saving = false;
                        this.gotoFirstValidationError();
                        return;
                    }

                    this.$toasted.show("Resource currently saving...");

                    let route = this.$laroute.route("api.resources.update.tags", {
                        resource: this.resource.id
                    });

                    axios
                        .put(route, this.form)
                        .then(response => {
                            this.$toasted.show("Resource saved.");
                            let resourceResponse = response.data.data;
                            this.$store.dispatch(
                                "setResourceValidation",
                                resourceResponse
                            );
                            this.$store.dispatch("setUnsavedData", false);

                            this.saving = false;
                        })
                        .catch(error => {
                            console.log(error);
                            this.displayError(error);
                        });
                });
            }
        },
        mounted() {
            this.$store.dispatch("getPillars");
            this.$store.dispatch("getTaxonomyGroups");

            const id = this.$route.params.id;
            this.$store.dispatch("getResource", { id: id });
        }
    };
</script>
